<app-base-modal
  [title]="'Дефекты'"
>
  <div class="fields">
    <mat-form-field
      appearance="outline"
      class="field"
    >
      <mat-label>Элемент товара</mat-label>
      <mat-select
        [(ngModel)]="selectedDefect"
        (selectionChange)="getDefectValues($event)"
      >
        <mat-option [value]="null"></mat-option>
        @for (option of defects; track $index) {
          <mat-option [value]="option.id">
            {{ option.title }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="field"
    >
      <mat-label>Типичный дефект</mat-label>
      <mat-select
        multiple
        [disabled]="!selectedDefect"
        [(ngModel)]="selectedDefectValues"
      >
        <mat-checkbox
          [checked]="isAllSelected()"
          (change)="toggleSelectAll()"
        >
          {{ isAllSelected() ? 'Снять все' : 'Выбрать все' }}
        </mat-checkbox>
        <mat-divider></mat-divider>
        @for (option of defectValues; track $index) {
          <mat-option [value]="option.id">
            {{ option.value }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="buttons-container">
    <button
      mat-button
      color="primary"
      (click)="handleSave()"
    >
      Сохранить
    </button>
    <button
      mat-button
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Отменить
    </button>
  </div>
</app-base-modal>
